var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',_vm._b({attrs:{"src":_vm.currentSrc,"alt":_vm.alt},on:{"error":_vm.handleError}},'v-img',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }